import FormSubmittedTick from '@/assets/Icons/components/FormSubmittedTick';
import ViewForm from '@/assets/Icons/components/ViewForm';
import Button from '@/components/Button/Button';
import { setSectionId } from '@/reducers/sectionIdSlice';
import { useGetSectionsDataQuery } from '@/services/userService/userServiceEndpoints';
import { getAuthData } from '@/utils/auth';
import { PostHogEvents } from '@/utils/PostHogEvents';
import { trackEvent } from '@/utils/track-event';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const FormSubmittedPage = () => {
  const navigate = useNavigate();
  const sectionId = useSelector((state: any) => state.sectionId.sectionId);
  const dispatch = useDispatch();

  const { districtId, email } = getAuthData();
  const { data: SectionItem } = useGetSectionsDataQuery(
    {
      districtId: districtId,
    },
    {
      skip: !districtId, // Skip the query if districtId is not available
      refetchOnMountOrArgChange: true, // Refetch when the component mounts or when districtId changes
    }
  );

  useEffect(() => {
    if (SectionItem?.data.section_responses[0]?.section_id) {
      dispatch(setSectionId(SectionItem?.data?.section_responses[0]?.section_id));
    }
  }, [SectionItem]);

  return (
    <div className="h-full flex flex-col items-center justify-center gap-4">
      <h1 className="text-ds-gray-800 text-2xl">Form Submitted Successfully.</h1>
      <FormSubmittedTick />
      <p className="text-gray-2250 text-sm">
        The Plaintiff Fact Sheet is submitted successfully. You can view your response by clicking
        the button below.
      </p>
      <Button
        color="primary"
        startIcon={<ViewForm />}
        onClick={() => {
          navigate(`/user/dashboard/instructions`);
          trackEvent(PostHogEvents.FORM_SUBMITTED, {
            form_id: sectionId,
            user_id: email,
            timestamp: new Date().toISOString(),
          });
        }}
      >
        View Form
      </Button>
    </div>
  );
};

export default FormSubmittedPage;
